var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.66663 40.3333H40.3333",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.875 7.33341V40.3334H26.125V7.33341C26.125 5.31675 25.3 3.66675 22.825 3.66675H21.175C18.7 3.66675 17.875 5.31675 17.875 7.33341Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.5 18.3334V40.3334H12.8333V18.3334C12.8333 16.3167 12.1 14.6667 9.9 14.6667H8.43333C6.23333 14.6667 5.5 16.3167 5.5 18.3334Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.1666 27.4999V40.3333H38.5V27.4999C38.5 25.4833 37.7666 23.8333 35.5666 23.8333H34.1C31.9 23.8333 31.1666 25.4833 31.1666 27.4999Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.d12283fa8c6c28c8fb63e65a181dfd67.svg";
export { ForwardRef as ReactComponent };